import { useEffect } from "react";
import Hero from "../../components/landing/Hero";
import Features from "../../components/landing/Features";
import InsuranceChoices from "../../components/landing/InsuranceChoices";
import Testimonials from "../../components/landing/Testimonials";
import CTA from "../../components/landing/CTA";
import NewsletterForm from "../../components/landing/NewsletterForm";
import Footer from "../../components/landing/Footer";

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow-x-hidden min-h-screen bg-gradient-to-br from-gray-50 to-white">
      {/* Hero Section */}
      <Hero />
      
      {/* Features Section*/}
      <Features />

      {/* Insurance Choices Section */}
      <InsuranceChoices />

      {/* Testimonials Section */}
      <Testimonials />

      {/* Newsletter Section */}
      <NewsletterForm />

      {/* CTA Section */}
      <CTA />

      {/* Footer */}
      <Footer />
    </div>
  );
}
